import { render } from "./PageBreadcrumbs.vue?vue&type=template&id=08865490&scoped=true"
import script from "./PageBreadcrumbs.vue?vue&type=script&lang=js"
export * from "./PageBreadcrumbs.vue?vue&type=script&lang=js"

import "./PageBreadcrumbs.vue?vue&type=style&index=0&id=08865490&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08865490"]])

export default __exports__